import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { BaseContext } from 'context/base.context';

import { useBackgroundImageService } from 'hooks/use-background-image-service.hook';

import { handleRedirectToPwa } from 'helpers/redirect-to-pwa';

import { TypographyVariants } from 'constants/typography-variants';
import { ExperimentsKeys } from 'constants/experiments';

import { Typography } from '../typography';
import { NextButton } from '../next-button';

import { useStyles } from './styles';
import { useExperimentStyles } from './styles';

export interface TipPageProps {
    imgSrc: string;
    text: {
        description: string,
        values?: string,
        components?: React.ReactElement[] | { readonly [tagName: string]: React.ReactElement },
        next?: string
    }
    handleClick?: () => void;
    needToRedirectToPwa?: boolean;
}

export const TipPage = ({ imgSrc, text, needToRedirectToPwa }: TipPageProps) => {
    const { tipPageWrapper, childrenWrapper } = useStyles();
    const { tipPageWrapperExp } = useExperimentStyles();

    const { pageConfiguration } = useContext(BaseContext);

    const { t } = useTranslation();

    const pageImages = useBackgroundImageService([imgSrc]);

    const handleClick = () => {

        if (needToRedirectToPwa) {
            handleRedirectToPwa();
        } else {
            pageConfiguration.handleOnPageComplete();
        }
    };

    const wl_first_screens_agency_experiment = localStorage.getItem(ExperimentsKeys.wl_first_screens_agency_experiment) === '1';

    return (
        <div className={`${tipPageWrapper} ${wl_first_screens_agency_experiment && tipPageWrapperExp}`}>
            <div className={childrenWrapper}>
                <div>
                    <img src={pageImages[0]} alt="" />

                    <Typography variant={TypographyVariants.tipPage}>
                        <Trans i18nKey={text.description} values={{value: text.values}} components={text.components} />
                    </Typography>
                </div>

                <NextButton
                    bottomMargin
                    onClick={handleClick}
                    typographyText={t(text?.next || 'Got it!')}
                />

            </div>
        </div>
    )
};
